import React from "react";
import Complex from "./Complex";
import Fractal from "./Fractal";
import ColourOptions from "./ColourOptions";
import { Divider, Button, FormControlLabel, Checkbox, TextField, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Card, Box, Container, Grid, Stack } from '@mui/material';
import "./FractalApp.css";

class FractalComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		  isDragging: false,
		  mouseDown: false,
		  dragStart: { r: 0, i: 0 },
		  dragEnd: { r: 0, i: 0 },
		  pixelStart: { x:0, y: 0},
		  pixelEnd: { x:0, y: 0},
		  processing: this.props.processing,
		  mouseCoordinates: { r: 0, i: 0 },
		  clickedPoint: props.centre,
		  colourOptions: props.colourOptions,
		  iterations: props.iterations,
		  iteration: 0,
		  increment: 1,
		  incrementalDrawing: false,
		  newlyEscaped: 0,
		  escapeCount: [],
		  centre: props.centre,
		  scale: props.scale,
		  fractalType: props.fractalType,
		  juliaConstant: props.juliaConstant,
		  escapeMatrix: [],
		  tempMatrix: [],
		  maxWorkers: props.workerCount,
		  timeStart: 0,
		  time: 0,
		  fractalImage: null
		};
		this.handleMouseMove = this.handleMouseMove.bind(this);
		this.handleRedraw = this.handleRedraw.bind(this);
		this.handleReiterate = this.handleReiterate.bind(this);
		this.handleReset = this.handleReset.bind(this);
		this.handleColourChange = this.handleColourChange.bind(this);
		this.getMouseCoordinates = this.getMouseCoordinates.bind(this);
		this.drawFractal = this.drawFractal.bind(this);
		this.interruptProcessing = this.interruptProcessing.bind(this);
		this.handleMouseDown = this.handleMouseDown.bind(this);
		this.handleMouseUp = this.handleMouseUp.bind(this);
		this.startWorkers = this.startWorkers.bind(this);
		this.initWorker = this.initWorker.bind(this);
		this.workerUrl = 'fractal/worker.js';
		this.workers = [];
		this.activeWorkers = 0;
	}

	checkWorkerScriptExists(url) {
	  return fetch(url)
		.then(response => {
		  if (response.status === 200) {
			return true; // URL exists
		  } else {
			return false; // URL does not exist
		  }
		})
		.catch(() => {
		  return false; // An error occurred, URL does not exist
		});
	}

	componentDidMount() {
		var { iteration, iterations, increment, juliaConstant, centre, scale, incrementalDrawing, fractalType, maxWorkers } = this.state;
		var canvas = this.canvasRef;
		var ctx = canvas.getContext("2d");
		var dimensions = { height: canvas.height, width: canvas.width };
		this.checkWorkerScriptExists(this.workerUrl).then(exists => {
			if (!exists) {
			  this.workerUrl='worker.js';
			} 
			for (var i=0;i<this.props.workerCount;i++){
				this.workers.push(new Worker(this.workerUrl));
			}
			var params = {
			  iteration,
			  iterations: incrementalDrawing ? increment : iterations,
			  juliaConstant: fractalType === "julia" ? juliaConstant : null,
			  centre,
			  scale,
			  dimensions,
			  maxWorkers
			}
			this.startWorkers(params);
		});
	}
  
	componentDidUpdate(prevProps,prevState) {
	  if (prevState.juliaConstant !== this.state.juliaConstant) {
		  this.props.onSharedStateChange({juliaConstant:this.state.juliaConstant});
		  console.log(this.state.fractalType);
		  if (this.state.fractalType == "julia") this.handleRedraw();
	  }
	  if (prevProps.juliaConstant !== this.props.juliaConstant && this.state.fractalType == "julia") {
		this.setState({ juliaConstant: this.props.juliaConstant });
	  }
	  if (prevState.processing !== this.state.processing) {
		this.props.onSharedStateChange({processing:this.state.processing});
	  }
	  if (prevProps.processing !== this.props.processing) {
		this.setState({processing: this.props.processing})
	  }
	  if (prevState.colourOptions !== this.state.colourOptions) {
		this.drawFractal();
	  }
	}
	
	handleColourChange(newColourOptions) {
		this.setState({ colourOptions: newColourOptions });
	}
	
	handleReset() {
	  var { centre, scale } = this.props;
	  var clickedPoint = centre;
	  this.setState({ centre, scale, clickedPoint }, ()=>{
		  this.scaleInputRef.value = scale;
		  this.redrawFractal(false);
	  });
	}
	
	interruptProcessing() {
	  this.setState({ processing:false });
	}

	drawFractal() {
		var {escapeMatrix, iterations, colourOptions} = this.state;
		var canvas = this.canvasRef;
		var ctx = canvas.getContext("2d");
		var escapeCount = Fractal.getEscapeCount(escapeMatrix, iterations);
		var palette = Fractal.buildPalette(escapeCount, colourOptions);
		Fractal.draw(escapeMatrix, iterations, ctx, palette);
		var imageData = ctx.getImageData(0, 0, this.canvasRef.width, this.canvasRef.height);
		this.setState({ fractalImage: imageData });
	}
	
	redrawFractal(reiterate) {
		var { centre, clickedPoint, juliaConstant, increment, iterations, fractalType, incrementalDrawing, iteration, escapeCount } = this.state;
		var canvas = this.canvasRef;
		var ctx = canvas.getContext("2d");
		var dimensions = { height: canvas.height, width: canvas.width };
		var newScale, newIterations, newIncrement, maxWorkers;
		newScale = parseFloat(this.scaleInputRef.value);
		newIterations = parseInt(this.iterationsInputRef.value);
		maxWorkers = parseInt(this.workersInputRef.value);
		if (reiterate) {
			newIterations += iterations;
		} else {
			iteration = 0;
			escapeCount = [dimensions.width*dimensions.height];
		}
		newIncrement = parseInt(this.incrementInputRef.value);
		var start = performance.now();

		this.setState({
		  scale: newScale,
		  iterations: newIterations,
		  increment: newIncrement,
		  centre: clickedPoint,
		  timeStart: start,
		  escapeCount,
		  iteration,
		  maxWorkers
		}, ()=> {
			var params = {
			  iteration,
			  iterations: incrementalDrawing ? newIncrement : newIterations,
			  juliaConstant: fractalType === "julia" ? juliaConstant : null,
			  centre: clickedPoint,
			  scale: newScale,
			  dimensions,
			  maxWorkers
			}
			this.startWorkers(params);
		});		
	}
	
	handleRedraw() {
		this.redrawFractal(false);
	}
	
	handleReiterate() {
		this.redrawFractal(true);
	}
	
	startWorkers(params) {
		var { iteration, iterations, juliaConstant, centre, scale, dimensions, maxWorkers } = params;
		console.log(params);
		var N = maxWorkers;
		if (N>this.workers.length) {
			for (var i = this.workers.length;i < N;i++){
				this.workers.push(new Worker(this.workerUrl));
			}
		} else if (N<this.workers.length) {
			while (this.workers.length > N){
				this.workers[this.workers.length-1].terminate();
				this.workers.pop();
			}
		}
		var localWidth = Math.floor(dimensions.width/N);
		var rStep = (4 / (dimensions.width * scale));
		var rMin = centre.r - 2 / scale;
		var rMax = rMin+rStep*localWidth*N;
		var trueMax = centre.r + 2 / scale;
		var colWidth = (rMax - rMin) / N;
		var localDimensions = { width: localWidth, height: dimensions.height };
		var matrices = Fractal.initialiseMatrices(juliaConstant, centre, scale, dimensions);
		var { escapeMatrix, zMatrix, cMatrix, unescaped } = matrices;
		var timeStart = performance.now();
		for (var i = 0;i<this.workers.length;i++) {
			this.activeWorkers++;
			this.initWorker(i);
		}
		this.setState({
			processing: true,
			iteration,
			timeStart,
			escapeMatrix,
			newlyEscaped: 0,
			tempMatrix: escapeMatrix
		}, () => {
			for (var i = 0; i < N; i++) {
				if ((i+1)===N) {
					localDimensions.width=localDimensions.width+(dimensions.width-(N*localWidth));
				}
				
				var localCentre = {
					r: rMin + (i * colWidth) + N * (colWidth) / 2 + (trueMax-rMax)/2,
					i: centre.i
				};
				this.workers[i].postMessage({
					iteration,iterations,juliaConstant,centre:localCentre,scale,dimensions:localDimensions 
				});
			}
		});
	}	
	
	initWorker(index) {
		var N = this.workers.length;
		var canvas = this.canvasRef;
		var ctx = canvas.getContext("2d");
		var dimensions = { height: canvas.height, width: canvas.width };
		var localWidth = Math.floor(dimensions.width/N);
		var palette;
		this.workers[index].onmessage = (e) => {
			var { escapeMatrix, iteration, newlyEscaped } = e.data;
			var { tempMatrix } = this.state;
			var latelyEscaped = this.state.newlyEscaped+newlyEscaped;
			for (var j in escapeMatrix) {
				var transposedIndex = parseInt(j) + index * localWidth;
				tempMatrix[transposedIndex] = escapeMatrix[j];
			}
			this.activeWorkers--;
			this.setState({ tempMatrix, newlyEscaped:latelyEscaped }, () => {
				if (this.activeWorkers == 0) {
					var { increment, incrementalDrawing, newlyEscaped, escapeCount, tempMatrix, tempzMatrix } = this.state;
					var time = performance.now() - this.state.timeStart;
					if (increment==1 && incrementalDrawing) {
						escapeCount = Fractal.getNextEscapeCount(escapeCount, newlyEscaped);
					} else {
						escapeCount = Fractal.getEscapeCount(tempMatrix, iteration);
					}
					this.setState({ escapeMatrix: tempMatrix, iteration, time, newlyEscaped: 0, escapeCount },()=>{
						var {
							colourOptions, 
							iterations, 
							juliaConstant, 
							fractalType, 
							centre, 
							scale,									
							processing
						} = this.state;
						juliaConstant = fractalType === "julia" ? juliaConstant : null;
						palette = Fractal.buildPalette(escapeCount, colourOptions);
						if (iteration<iterations) {
							this.progressRef.textContent = `Iteration ${iteration} of ${iterations}`;
							this.startWorkers({iteration, iterations:increment, juliaConstant, centre, scale, dimensions, maxWorkers:N});
						} else {
							this.progressRef.textContent = ``;
							escapeCount = [dimensions.width*dimensions.height];
							this.setState({processing:false});
						}
						Fractal.draw(tempMatrix, iterations, ctx, palette);
						var imageData = ctx.getImageData(0, 0, this.canvasRef.width, this.canvasRef.height);
						this.setState({ fractalImage: imageData })
					});		
				}
			});
		};
	}


	getMouseCoordinates(event){
		var canvas = this.canvasRef;
		var rect = canvas.getBoundingClientRect();
		var dimensions = { height: canvas.height, width: canvas.width };
		var x = event.clientX - rect.left;
		var y = event.clientY - rect.top;
		return Complex.pixelToComplex(x, y, dimensions, this.state.centre, this.state.scale);
	}

	getMousePixelCoordinates(event){
		var canvas = this.canvasRef;
		var rect = canvas.getBoundingClientRect();
		var x = event.clientX - rect.left;
		var y = event.clientY - rect.top;
		return {x,y};
	}

	handleMouseDown(event) {
		event.preventDefault();
		if (!this.state.processing) {
			var point = this.getMouseCoordinates(event);
			var pixel = this.getMousePixelCoordinates(event);
			this.setState({ mouseDown: true, dragStart: point, pixelStart: pixel});
		}
	}
	
	handleMouseUp(event) {
		var point = this.getMouseCoordinates(event);
		this.setState({ mouseDown: false });
		if (this.state.isDragging){
		  var pixel = this.getMousePixelCoordinates(event);
		  this.setState({ dragEnd: point, pixelEnd: pixel}, this.updateZoomAndCenter);
		} else {
			if (!this.state.processing){
				if (!event.shiftKey){
				  if (!event.ctrlKey){
					this.setState({ clickedPoint: point }, this.handleRedraw);
				  } else {
					var newScale = this.state.scale/3;
					if (this.scaleInputRef) {
						this.scaleInputRef.value = newScale;
					}
					this.setState({ clickedPoint: point, scale: newScale }, this.handleRedraw); 
				  }
				}
				if (this.props.fractalType === "mandelbrot" && event.shiftKey) {
				  this.setState({juliaConstant:point});
				}
			}			
		}
	}

	handleMouseMove(event) {
	  var point = this.getMouseCoordinates(event);
	  var pixel = this.getMousePixelCoordinates(event);
	  this.setState({ mouseCoordinates: point });
	  if (this.state.mouseDown && this.state.fractalImage && !event.shiftKey && !event.ctrlKey && !this.state.processing){
		this.setState({ isDragging: true, dragEnd: point, pixelEnd: pixel});
		//draw the zoom box
		this.drawZoomBox();
	  } else {
		this.setState({isDragging:false});
	  }
	}

	drawZoomBox() {
		const ctx = this.canvasRef.getContext("2d");
		const { pixelStart, pixelEnd } = this.state;
		const { fractalImage } = this.state;

		// Set your desired box styles (color, width, etc.)
		ctx.strokeStyle = "gray";
		ctx.lineWidth = 2;

		// Calculate the dimensions of the box
		const x = Math.min(pixelStart.x, pixelEnd.x);
		const y = Math.min(pixelStart.y, pixelEnd.y);
		const width = Math.abs(pixelStart.x - pixelEnd.x);
		const height = Math.abs(pixelStart.y - pixelEnd.y);

		// Clear the previous zoom box
		if (fractalImage) {
			ctx.putImageData(fractalImage, 0, 0);
		}

		// Draw the zoom box
		ctx.strokeRect(x, y, width, height);
	}
  
	updateZoomAndCenter() {
		var { dragStart, dragEnd, clickedPoint, scale } = this.state;
		var ctx = this.canvasRef.getContext("2d");

		var dr = Math.abs(dragStart.r-dragEnd.r);
		var di = Math.abs(dragStart.i-dragEnd.i);

		var boxWidth = Math.max(dr,di);
		var newScale;
		if (boxWidth > 0) {
			newScale = 4/boxWidth;
		}
		if (newScale){
		  if (this.scaleInputRef) {
			this.scaleInputRef.value = newScale;
		  }
		  
		  var newCentre = {
			r: (dragStart.r+dragEnd.r)/2,
			i: (dragStart.i+dragEnd.i)/2
		  };

		  this.setState({ scale: newScale, clickedPoint: newCentre }, this.handleRedraw);
		}

		if (this.state.fractalImage) {
			ctx.clearRect(0, 0, this.canvasRef.width, this.canvasRef.height);
			ctx.putImageData(this.state.fractalImage, 0, 0);
		}
	}
	
  render() {
    var { clickedPoint, centre, scale, increment, iterations, mouseCoordinates, colourOptions, fractalType, juliaConstant, processing, incrementalDrawing, time, maxWorkers } = this.state;

    return (
		<Box>	
			<Stack justifyContent="center">
				<Typography variant="h6" component="h2">
					{this.props.title}{fractalType === "julia" && (" c="+parseFloat(juliaConstant.r.toFixed(15))+"+"+parseFloat(juliaConstant.i.toFixed(15)+"i"))}
				</Typography>
			</Stack>
			<Stack direction="row" spacing={2}>
				<Box>
					<canvas
						ref={(ref) => {
							this.canvasRef = ref;
						}}
						width={this.props.canvasDimensions.width}
						height={this.props.canvasDimensions.height}
						onMouseMove={this.handleMouseMove}
						onMouseDown={this.handleMouseDown}
						onMouseUp={this.handleMouseUp}
					>
						Your browser does not support the HTML canvas tag.
					</canvas>
				</Box>

				<Stack spacing={1}>
					<Stack direction="row" spacing={1}>
						<Stack justifyContent="center"><Typography>Centre:</Typography></Stack>
						<Table size="small" padding="none">
						<TableBody>
						<TableRow><TableCell>r:{parseFloat(centre.r.toFixed(8))}</TableCell></TableRow> 
						<TableRow><TableCell>i:{parseFloat(centre.i.toFixed(8))}</TableCell></TableRow>
						</TableBody>
						</Table>
					</Stack>
					<TextField
						label="Zoom Scale"
						type="number"
						size="small"
						margin="dense"
						defaultValue={scale}
						inputProps={{
							ref:(ref) => {
								this.scaleInputRef = ref;
							},
							step:"0.5",
							min:"1",
							max:"100000"
						}}           
					/>
					<Button variant="outlined" disabled={this.state.processing} onClick={this.handleReset}>Reset</Button>
					<Divider/>
					<ColourOptions
						cycle={colourOptions.cycle}
						exponent={colourOptions.exponent}
						redOffset={colourOptions.redOffset}
						greenOffset={colourOptions.greenOffset}
						blueOffset={colourOptions.blueOffset}
						onColourChange={this.handleColourChange}
					/>
					<Divider/>
					<TextField
						label="Iterations"
						type="number"
						size="small"
						margin="dense"
						defaultValue={iterations}
						inputProps={{
							ref:(ref) => {
								this.iterationsInputRef = ref;
							},
							step:"100",
							min:"0",
							max:"100000"
						}}           
					/>
					<TextField
						label="Worker Threads"
						type="number"
						size="small"
						margin="dense"
						defaultValue={maxWorkers}
						inputProps={{
							ref:(ref) => {
								this.workersInputRef = ref;
							},
							step:"1",
							min:"1",
							max:"10"
						}}           
					/>
					<FormControlLabel 
						control={
							<Checkbox 
							checked={this.state.incrementalDrawing}	
							size="small"
							onChange={(event) => this.setState({ incrementalDrawing: event.target.checked })} 		 
							/>
						}
						disabled={this.state.processing}
						label="Incremental Drawing"
					/>
					<TextField
						label="Increment"
						type="number"
						size="small"
						margin="dense"
						defaultValue={increment}
						inputProps={{
							ref:(ref) => {
								this.incrementInputRef = ref;
							},
							step:"1",
							min:"1",
							max:"1000"
						}}
						disabled={!this.state.incrementalDrawing || this.state.processing}
					/>
					{(incrementalDrawing && processing) ? (
					<Button variant="outlined" onClick={this.interruptProcessing}>Stop Drawing</Button>
					) : (
					<Button variant="outlined" disabled={this.state.processing} onClick={this.handleRedraw}>Redraw</Button>
					)}
					<Button sx={{display:'none'}} variant="outlined" disabled={this.state.processing} onClick={this.handleRedraw}>Reiterate</Button>
				</Stack>
			</Stack> 
			<Stack direction="row" useFlexGap spacing={1}>	
				<Typography>
						<strong>Time Taken:</strong> {time} ms
				</Typography>
				<Typography ref={(ref) => this.progressRef = ref}></Typography>
				<Stack direction="row" spacing={1} sx={{display:'none'}}>
					<Stack justifyContent="center"><Typography>Mouse Coordinates:</Typography></Stack>
					<Table size="small" padding="none">
					<TableBody>
					<TableRow><TableCell>r:{parseFloat(mouseCoordinates.r.toFixed(8))}</TableCell></TableRow> 
					<TableRow><TableCell>i:{parseFloat(mouseCoordinates.i.toFixed(8))}</TableCell></TableRow>
					</TableBody>
					</Table>
				</Stack>
			</Stack>
		</Box>
    );
  }
}

export default FractalComponent;